const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Format a date value as DD-MMM-YY  (e.g. 01-Mar-26)
 * @param {string|Date|number} val  – any value parseable by Date()
 * @param {string} [fallback='—']   – returned when val is falsy / invalid
 */
export function formatDate(val, fallback = '—') {
  if (!val) return fallback;
  const d = new Date(val);
  if (isNaN(d.getTime())) return fallback;
  const dd = String(d.getDate()).padStart(2, '0');
  const mmm = MONTHS[d.getMonth()];
  const yy = String(d.getFullYear()).slice(-2);
  return `${dd}-${mmm}-${yy}`;
}

/**
 * Return today's date as YYYY-MM-DD (for <input type="date"> defaulting)
 */
export function todayISO() {
  const d = new Date();
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}
